import { ReactNode, type FunctionComponent } from 'react';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import env from '../../../config/env';
import breakpoints from '../../../utils/breakpoints';
import navigationFooterLabels from '../../../utils/navigationFooterLabels';
import { redirectToDashboard } from '../../../utils/redirectMethods';
import useCurrentWidth from '../../commons/use-current-width/useCurrentWidth';
import Layout from '../../layout/Layout';
import surveyImageDesktop from '../../../assets/images/survey-image-desktop.svg';
import surveyImageMobile from '../../../assets/images/survey-image-mobile.svg';
import * as footerStyles from '../../App.module.css';
import * as styles from './ConfirmationPage.module.css';

interface ConfirmationPageProps {
  isTrial: boolean;
  header?: ReactNode;
}

const ConfirmationPage: FunctionComponent<ConfirmationPageProps> = ({ isTrial, header }) => {
  const width = useCurrentWidth();
  const isDesktop = width > breakpoints.medium;

  const nextButton = {
    label: navigationFooterLabels.GO_TO_HOMEPAGE,
    onClick: () => redirectToDashboard(),
  };

  const image = width < breakpoints.small ? surveyImageMobile : surveyImageDesktop;
  const footerWrapperStyles = `${footerStyles.footerWrapper} ${
    isTrial ? '' : footerStyles.isPublic
  }`;

  return (
    <>
      {header}
      <Layout nextButton={nextButton} displayNavigationFooter={isTrial} displayBreakLine={isTrial}>
        <div className={styles.confirmationPageContainer}>
          <img className={styles.headerImage} src={image} alt="" />
          <h1 className={styles.title}>Hooray! We&apos;ve received your survey.</h1>
          <p className={styles.message}>
            Your selections have been saved. {isTrial && 'Click below to continue to the homepage.'}
          </p>
        </div>
      </Layout>
      <div
        className={`${footerWrapperStyles} ${isDesktop ? footerStyles.footerWrapperWelcome : ''}`}
      >
        <GlobalFooter minimalFooter chatbotConfig={{ agentId: env.CHATBOT_AGENT_ID }} />
      </div>
    </>
  );
};

ConfirmationPage.displayName = 'ConfirmationPage';

export default ConfirmationPage;
